import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { COURIER, PATNERS, ZONE } from "helpers/url_helper";
import { post, get } from 'helpers/api_helper'
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";

const PatnerForm = ({cb = () => {}, data = null}) => {
    const [formData, setFormData ] = useState({
        id: data?.id || '',
        name: data?.name || '',
        email: data?.email || '',
        phone: data?.phone || '',
        address: data?.address || '',
        city: data?.city || '',
        state: data?.state || '',
        country: data?.country || '',
        pincode: data?.pincode || '',
        b2b_cod_fix: data?.b2b_cod_fix || '',
        b2b_cod_per: data?.b2b_cod_per || '',
        b2c_cod_fix: data?.b2c_cod_fix || '',
        b2c_cod_per: data?.b2c_cod_per || '',
    });
    const [patnersList, setPatnersList] = useState([]);
    const [zones, setZones] = useState([]);
    const [rateData, setRateData] = useState(() => {
        try {
            return data?.rates ? JSON.parse(data?.rates) : {};
        } catch (error) {
            console.error('Error parsing rates:', error);
            return {};
        }
    });

    const getPatnersList = async () => {
        const [patnersResponse, zoneResponse] = await Promise.all([
            get(`${COURIER}/options`),
            get(`${ZONE}/options`)
        ]);
        
        if (patnersResponse.success) setPatnersList(patnersResponse.data);
        if (zoneResponse.success) setZones(zoneResponse.data);
    }

    useEffect(() => {
        getPatnersList();
    },[])

    // Add this handler function before the return statement
    const handleRateChange = (e, zoneId, partnerId, type) => {
        const value = e.target.value;
        setRateData(prev => ({
            ...prev,
            [zoneId]: {
                ...prev[zoneId],
                [partnerId]: {
                    ...prev[zoneId]?.[partnerId],
                    [type]: value
                }
            }
        }));
    };

    // Update the table inputs in the render section
    <tbody>
        {zones?.map((zone, zIndex) => (
            <tr key={`R_${zIndex}`}>
                <td>{zone.label}</td>
                {patnersList?.map((partner, pIndex) => (
                    <td key={`FR_${pIndex}`}>
                        <input 
                            className="form-control form-control-sm mb-1"
                            value={rateData[zone.value]?.[partner.value]?.halfKg || ''}
                            onChange={(e) => handleRateChange(e, zone.value, partner.value, 'halfKg')}
                            placeholder="0.5Kg Price"
                        />
                        <input 
                            className="form-control form-control-sm"
                            value={rateData[zone.value]?.[partner.value]?.oneKg || ''}
                            onChange={(e) => handleRateChange(e, zone.value, partner.value, 'oneKg')}
                            placeholder="1Kg Price"
                        />
                    </td>
                ))}
            </tr>
        ))}
    </tbody>

    // Update the handelSubmit function to include rates
    const handelSubmit = async(e) => {
        e.preventDefault();
        try {            
            const submitData = {
                ...formData,
                rates: JSON.stringify(rateData)
            };
            const res = await post(PATNERS, submitData);
            if(res.success){
                showSuccessAlert('partner created successfully', () => {
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        address: '',
                        city: '',
                        state: '',
                        country: '',
                        pincode: '',
                        b2b_cod_fix: '',
                        b2b_cod_per: '',
                        b2c_cod_fix: '',
                        b2c_cod_per: '',
                    });
                    setRateData({});
                });
                cb();
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to create partner');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Branches " /> New Patner</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <input type="hidden" name="id" value={formData?.id || ''} />
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="name">Patner Name</label>
                                        <input type="text" className="form-control" id="name" name="name" value={formData?.name} onChange={handleInputChange} placeholder="Patner Name" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input type="text" className="form-control" id="email" name="email" value={formData?.email} onChange={handleInputChange} placeholder="Email" />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone</label>
                                        <input type="text" className="form-control" id="phone" name="phone" value={formData?.phone} onChange={handleInputChange} placeholder="Phone" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <textarea type="text" className="form-control" id="address" name="address" value={formData?.address} onChange={handleInputChange} placeholder="Address" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="city">City</label>
                                        <input type="text" className="form-control" id="city" name="city" value={formData?.city} onChange={handleInputChange} placeholder="City" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="state">State</label>
                                        <input type="text" className="form-control" id="state" name="state" value={formData?.state} onChange={handleInputChange} placeholder="State" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="country">Country</label>
                                        <input type="text" className="form-control" id="country" name="country" value={formData?.country} onChange={handleInputChange} placeholder="Country" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="pincode">Pincode</label>
                                        <input type="text" className="form-control" id="pincode" name="pincode" value={formData?.pincode} onChange={handleInputChange} placeholder="Pincode" required />
                                    </div>
                                </Col>
                            </Row>

                            <div className="p-2 mt-2" style={{border: '1px solid #919191FF'}}>
                                <label>COD Charges</label>
                                <Row className="mt-">
                                    <Col>
                                        <div className="form-group">
                                            <label>B2B minimum Price</label>
                                            <input 
                                                className="form-control" 
                                                id="b2b_cod_fix"
                                                name="b2b_cod_fix"
                                                value={formData?.b2b_cod_fix || ''}
                                                onChange={handleInputChange}
                                                placeholder="COD Fixed Price" 
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div>
                                            <label>B2B percentage</label>
                                            <input 
                                                className="form-control" 
                                                id="b2b_cod_per"
                                                name="b2b_cod_per"
                                                value={formData?.b2b_cod_per || ''}
                                                onChange={handleInputChange}
                                                placeholder="COD Commition in %" 
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col>
                                        <div className="form-group">
                                            <label>B2C minimum Price</label>
                                            <input 
                                                className="form-control" 
                                                id="b2c_cod_fix"
                                                name="b2c_cod_fix"
                                                value={formData?.b2c_cod_fix || ''}
                                                onChange={handleInputChange}
                                                placeholder="COD Fixed Price" 
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div>
                                            <label>B2C percentage</label>
                                            <input 
                                                className="form-control"
                                                id="b2c_cod_per"
                                                name="b2c_cod_per"
                                                value={formData?.b2c_cod_per || ''}
                                                onChange={handleInputChange}
                                                placeholder="COD Commition in %" 
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>


                            <Row className="mt-3">
                                <h5>Rates</h5>
                                <Col>
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <table className="table table-bordered">
                                            <thead style={{
                                                position: 'sticky',
                                                top: 0,
                                                backgroundColor: '#fff',
                                                zIndex: 1
                                            }}>
                                                <tr>
                                                    <th style={{ minWidth: '100px' }}></th>
                                                    {patnersList?.map((item, index) => (
                                                        <th key={`FR_${index}`} style={{ minWidth: '200px' }}>
                                                            {item.label}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {zones?.map((zone, zIndex) => (
                                                    <tr key={`R_${zIndex}`}>
                                                        <td>{zone.label}</td>
                                                        {patnersList?.map((partner, pIndex) => (
                                                            <td key={`FR_${pIndex}`}>
                                                                <input 
                                                                    className="form-control form-control-sm mb-1" 
                                                                    value={rateData[zone.value]?.[partner.value]?.halfKg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, 'halfKg')}
                                                                    placeholder="0.5Kg Price" 
                                                                />
                                                                <input 
                                                                    className="form-control form-control-sm" 
                                                                    value={rateData[zone.value]?.[partner.value]?.fullKg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, 'fullKg')}
                                                                    placeholder="1Kg Price" 
                                                                />
                                                                <input 
                                                                    className="form-control form-control-sm" 
                                                                    value={rateData[zone.value]?.[partner.value]?._2Kg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, '_2Kg')}
                                                                    placeholder="2Kgs Price" 
                                                                />
                                                                <input 
                                                                    className="form-control form-control-sm" 
                                                                    value={rateData[zone.value]?.[partner.value]?._5Kg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, '_5Kg')}
                                                                    placeholder="5Kgs Price" 
                                                                />
                                                                <input 
                                                                    className="form-control form-control-sm" 
                                                                    value={rateData[zone.value]?.[partner.value]?._10Kg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, '_10Kg')}
                                                                    placeholder="10Kgs Price" 
                                                                />
                                                                <input 
                                                                    className="form-control form-control-sm" 
                                                                    value={rateData[zone.value]?.[partner.value]?._1xKg || ''}
                                                                    onChange={(e) => handleRateChange(e, zone.value, partner.value, '_1xKg')}
                                                                    placeholder="Extraa Per Kg Price" 
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2 " style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default PatnerForm;